<div mat-dialog-title style="margin-top: 3%;">
  <div class="d-flex justify-content-between">
      {{selectedCheckList.clFullName}}
      <i class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>
<div mat-dialog-content>
  <div class="row m-0">
      <div class="col-12 p-0">
          <div style="margin-top: 2%;">
              <kendo-grid [kendoGridBinding]="checklistItemList" [reorderable]="true" [sortable]="false" [resizable]="true" [filterable]="false" [pageSize]="40" class="k-resizable-grid" [pageable]="true">
                  <ng-template kendoPagerTemplate>
                      <div class="k-pager-left">
                          <kendo-pager-info></kendo-pager-info>
                      </div>
                      <div class="k-pager-right">
                          <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                          <kendo-pager-input></kendo-pager-input>
                          <kendo-pager-next-buttons></kendo-pager-next-buttons>
                      </div>
                  </ng-template>
                  <kendo-grid-column title="Sl.No." filterable="false" width="60">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                          <span *ngIf="dataItem.displayAction" class="no-wrap">
                              {{rowIndex+1}}
                          </span>
                          <span *ngIf="dataItem.displayAction == false" style="font-size: 17px;text-transform: capitalize;font-family: 'Roboto-Bold'" class="no-wrap" eipTooltip="{{dataItem.cliDescription}}" eipTooltipPosition="auto">
                              {{rowIndex+1}}
                          </span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="cliDescription" title="Activity" width="300">
                      <ng-template kendoGridCellTemplate let-dataItem>
                          <span *ngIf="dataItem.displayAction" class="no-wrap" eipTooltip="{{dataItem.cliDescription}}" eipTooltipPosition="auto">
                              {{dataItem.cliDescription}}
                          </span>
                          <span *ngIf="dataItem.displayAction == false" style="font-size: 20px;text-transform: capitalize;font-family: 'Roboto-Bold'" class="no-wrap" eipTooltip="{{dataItem.cliDescription}}" eipTooltipPosition="auto">
                              {{dataItem.cliDescription}}
                          </span>
                          <span *ngIf="dataItem.isMandatory  == true" style="color:red"> * </span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="clAction" title="Actions" width="180">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                          <span *ngIf="dataItem.displayAction">
                              <input type="radio" [disabled]="isReadMode" name="clAction{{dataItem.cliId}}" id="1{{dataItem.cliId}}" [value]="1" [(ngModel)]="dataItem.isChecked" kendoRadioButton />
                              <label class="k-label" style="margin-left: 2%;" for="1{{dataItem.cliId}}">Yes</label>&nbsp;&nbsp;
                              <input type="radio" [disabled]="isReadMode" name="clAction{{dataItem.cliId}}" id="2{{dataItem.cliId}}" [value]="2" [(ngModel)]="dataItem.isChecked" kendoRadioButton />
                              <label class="k-label" style="margin-left: 2%;" for="2{{dataItem.cliId}}">No</label>&nbsp;&nbsp;
                              <input type="radio" [disabled]="isReadMode" name="clAction{{dataItem.cliId}}" id="3{{dataItem.cliId}}" [value]="3" [(ngModel)]="dataItem.isChecked" kendoRadioButton />
                              <label class="k-label" style="margin-left: 2%;" for="3{{dataItem.cliId}}">NA</label>
                          </span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="Remarks" field=remarks width="230">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                          <span *ngIf="dataItem.displayAction">
                              <input type="text" placeholder="Enter Remarks" [disabled]="isReadMode" style="border: none; border-bottom: 1px solid; width: 100%; background: none;" #remark="ngModel" [(ngModel)]="dataItem.remarks" required pattern=".*[^ ].*">
                              <!-- required pattern=".*[^ ].*" -->
                              <div *ngIf="dataItem.isMandatory  == true">
                                  <div *ngIf="dataItem.isChecked != null && dataItem.isChecked != 1 && remark.invalid" style="color: red;font-size: 12px;">
                                      Remark Field is Required
                                  </div>
                              </div>
                              
                          </span>
                      </ng-template>
                  </kendo-grid-column>
              </kendo-grid>
          </div>
      </div>
  </div>
</div>
<div mat-dialog-actions>
  <div class="row justify-content-end flex-grow-1">
      <button class="btn btn-primary" type="submit" *ngIf="!isReadMode" (click)="onclick_Submit(false)" [disabled]="isAllButtonDisable"><i class="fa fa-save" title="Submit" aria-hidden="true"></i>&nbsp;&nbsp;Submit</button>
      <button class="btn btn-primary" type="submit" *ngIf="!isReadMode" (click)="onclick_Submit(true)" [disabled]="isApproveDisable"><i class="fa fa-check-circle-o" title="Approve" aria-hidden="true"></i>&nbsp;&nbsp;Approve</button>
  </div>
</div>